import { render, staticRenderFns } from "./UnpairedDatasetElementView.vue?vue&type=template&id=6f586d64&"
import script from "./UnpairedDatasetElementView.vue?vue&type=script&lang=js&"
export * from "./UnpairedDatasetElementView.vue?vue&type=script&lang=js&"
import style0 from "./UnpairedDatasetElementView.vue?vue&type=style&index=0&id=6f586d64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports